import {useLocation} from 'react-router-dom';
import {Text} from '@esgi/ui/typography';
import {AppliedTo, Filenametemplate, TextIcon, SightWords} from '@esgi/ui/icons';

export function Title() {
	const {pathname} = useLocation();
	const data = {
		'/activities/bingo': [AppliedTo, 'Bingo'],
		'/activities/flashcards': [Filenametemplate, 'Flashcards'],
		'/activities/writing-practice': [TextIcon, 'Writing Practice'],
		'/activities/sight-words': [SightWords, 'Sight Words'],
	};
	const [Icon = null, text = ''] = data[pathname];

	return (
		<>
			<Icon/>
			<Text size='small' data-cy='activity-title'>{text}</Text>
		</>
	);
}
